import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColumnWideRemove: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="column-wide-remove">
      <path
        d="M3 19H2V20H3V19ZM3 5V4H2V5H3ZM12 19V20H13V19H12ZM21 5H22V4H21V5ZM20 10V11H22V10H20ZM4 19V5H2V19H4ZM12 18H3V20H12V18ZM20 5V10H22V5H20ZM3 6H12V4H3V6ZM12 6H21V4H12V6ZM13 19V5H11V19H13Z"
        fill="currentColor"
      />
      <path
        d="M17.7071 14.2929L17 13.5858L15.5858 15L16.2929 15.7071L17.7071 14.2929ZM20.2929 19.7071L21 20.4142L22.4142 19L21.7071 18.2929L20.2929 19.7071ZM16.2929 18.2929L15.5858 19L17 20.4142L17.7071 19.7071L16.2929 18.2929ZM21.7071 15.7071L22.4142 15L21 13.5858L20.2929 14.2929L21.7071 15.7071ZM16.2929 15.7071L18.2929 17.7071L19.7071 16.2929L17.7071 14.2929L16.2929 15.7071ZM18.2929 17.7071L20.2929 19.7071L21.7071 18.2929L19.7071 16.2929L18.2929 17.7071ZM17.7071 19.7071L19.7071 17.7071L18.2929 16.2929L16.2929 18.2929L17.7071 19.7071ZM19.7071 17.7071L21.7071 15.7071L20.2929 14.2929L18.2929 16.2929L19.7071 17.7071Z"
        fill="currentColor"
      />
    </CentralIconBase>
  );
};

export default IconColumnWideRemove;
